import type { CopilotProvider, CopilotProviderId } from "../types";
import { orkestriaProvider } from "./orkestria";
import { ollamaCloud, ollamaLocal } from "./ollama";
import {
  cerebrasProvider,
  groqProvider,
  openRouterProvider,
} from "./openaiCompatible";

export const PROVIDERS: Record<CopilotProviderId, CopilotProvider> = {
  orkestria: orkestriaProvider,
  "ollama-local": ollamaLocal,
  "ollama-cloud": ollamaCloud,
  groq: groqProvider,
  openrouter: openRouterProvider,
  cerebras: cerebrasProvider,
};

/** Lista expuesta al usuario — Orkestria primero como recomendado. */
export const PROVIDER_LIST: CopilotProvider[] = [
  orkestriaProvider,
  ollamaLocal,
  groqProvider,
  openRouterProvider,
  cerebrasProvider,
  ollamaCloud,
];

export function getProvider(id: CopilotProviderId): CopilotProvider {
  return PROVIDERS[id] ?? orkestriaProvider;
}
